import { PropsWithChildren } from 'react';

import { LicenseEventsJoinMetadata, LicenseScope } from '@common-lib';

import { ActiveLicenses } from './active-licenses.interface';
import { LicenseConsumer } from './license-consumer.component';
import { useIsLicensesOnline } from './use-is-licenses-online';
import { useLicense } from './use-license';
import { useLicenses } from './use-licenses';

export interface GenerateLicenseConsumerOptions<
  TActiveLicenses extends ActiveLicenses,
> {
  scope: LicenseScope;
  defaultLicenses: TActiveLicenses;
}

export const generateLicenseConsumer = <TActiveLicenses extends ActiveLicenses>(
  options: GenerateLicenseConsumerOptions<TActiveLicenses>,
) => {
  return {
    LicenseConsumer: ({
      organizationId,
      children,
      ...metadata
    }: PropsWithChildren<
      {
        organizationId: string | undefined;
      } & LicenseEventsJoinMetadata
    >) => (
      <LicenseConsumer
        scope={options.scope}
        organizationId={organizationId}
        metadata={metadata}
        defaults={options.defaultLicenses}
      >
        {children}
      </LicenseConsumer>
    ),
    useLicense: (key: keyof TActiveLicenses & string) => {
      return useLicense<TActiveLicenses>(key);
    },
    useLicenses: () => {
      return useLicenses<TActiveLicenses>();
    },
    useIsLicensesOnline: () => {
      return useIsLicensesOnline();
    },
  };
};
